<template>
    <div>
        <div :class="{ active : isOpen }" class="vue-filter-bg" @click="handleCloseFilterSet"></div>
        <div :class="{ active : isOpen }" id="vehicle-filter-set" class="vue-filter-set vue-filter-set-v2">
            <div class="filter-group-wrapper">
                <aut-filter-group
                    v-for="(filter, key) in filterSet"
                    :key="key"
                    :label="filter.label"
                    :group-id="key"
                    :options="filter.options"
                    @active-filters-changed="handleActiveFiltersChanged"
                    :event-bus="eventBus"
                ></aut-filter-group>
            </div>

            <div class="button-wrapper d-flex justify-content-between d-lg-none">
                <button @click="handleClearFilters" class="color-text font-weight-bold">{{ translations.clearText}}</button>

                <button class="btn-primary m-0" @click="handleCloseFilterSet">{{ translations.showText}} ({{ filterAmount }})</button>
            </div>
        </div>
    </div>
</template>

<script>
import FilterGroup from "./FilterGroupV2";
import translations from "../../mixins/translations";

export default {
    name: "FilterSet",

    mixins: [translations],

    components: {
        'aut-filter-group': FilterGroup,
    },

    props: {
        filterSet: {
            type: Object
        },
        isOpen: {
            type: Boolean
        },
        filterAmount: {
            type: Number,
        },
        eventBus: {}
    },

    data() {
        return {
            selectedFilters: [],
            open: this.isOpen,
        }
    },
    methods: {
        handleActiveFiltersChanged(filterGroup) {

            let foundFilter = lodash.find(this.selectedFilters, (o) => {
                return o.groupId === filterGroup.groupId;
            });

            if (!lodash.isNil(foundFilter) && lodash.isEmpty(filterGroup.filters)) {
                this.selectedFilters.splice(lodash.findKey(this.selectedFilters, (e) => {
                    return e.groupId === filterGroup.groupId;
                }), 1);

                return;
            }

            if (lodash.isEmpty(filterGroup.filters)) {
                return;
            }

            if (!lodash.isNil(foundFilter) && !lodash.isEmpty(filterGroup.filters)) {
                foundFilter.filters = filterGroup.filters;

                return;
            }

            this.selectedFilters.push(filterGroup);
            this.$emit('filters-changed', this.selectedFilters);
        },

        handleClearFilters() {
            this.eventBus.$emit('clear-filters');
        },

        handleCloseFilterSet() {
            this.open = false;

            document.body.classList.remove('body-overlay');

            this.$emit('toggle-filter-set', false);
        }
    }
}
</script>
